MIN_TIME_VISIBLE